// redeploy
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
// Self-hosted Inter (replaces the Google Fonts CDN link — no external
// resource, so no Sub-Resource-Integrity finding). Weights match --font-sans.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
// Initialize Supabase client early, before any components use it
import '@/lib/supabase';
import { initializeAnalytics } from '@/lib/analytics';
import { addBreadcrumb, initSentry, reportMessage } from '@/lib/sentry';
import { installStaleChunkRecovery } from '@/lib/staleChunk';
import App from './App.tsx';

initSentry();

// Recover the session when a promotion lands while the app is open and the
// chunk map in memory goes stale (YARUTA-WEB-6 / YARUTA-WEB-7). Installed
// right after Sentry so the recovery itself is reportable.
installStaleChunkRecovery({
  addEventListener: (type, listener) => window.addEventListener(type, listener),
  reload: () => window.location.reload(),
  now: () => Date.now(),
  getItem: (key) => window.sessionStorage.getItem(key),
  setItem: (key, value) => window.sessionStorage.setItem(key, value),
  report: (message, data) => {
    addBreadcrumb(message, data);
    reportMessage(message, data);
  },
});

const analyticsClient = initializeAnalytics();
const app = analyticsClient ? (
  <PostHogProvider client={analyticsClient}>
    <App />
  </PostHogProvider>
) : (
  <App />
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>{app}</StrictMode>,
);
